<template lang="pug">
  div
    button.btn.btn-success.sel-users-btn(v-if="!view_mode" type="button", @click="openModalSelUser", data-testid="btn-sel-users") {{buttonName}}
    .selected-box
      div.label.bcard-search-user-selected(v-for="(item, index) in modalSelUser.selectedItems", :key="item.id" :title="item.full_name", data-testid="-selected-user")
        input(type="hidden", :name="inputName", v-model="item.id")
        span {{item.full_name}}
        i.fa.fa-times(v-if="!view_mode" @click="removeSelectedUser(index)")

    //- 既存データを消すためのhidden
    input(
      v-if="maxSelect === '1' && modalSelUser.selectedItems.length === 0",
      type="hidden",
      :name="inputName",
      value=""
    )

    //- 余計なフォームデータが埋め込まれないように、使わないときは隠す
    //- と思ったけど、v-modelをwatchできなくなるのでここでやるのはやめた
    modal-sel-user(v-model="modalSelUser", :maxSelect="maxSelect", :getDels="getDels", @input="onChangeSelectedUsers")
</template>

<script>
import ModalSelUser from '@/components/organisms/ModalSelUser'

export default {
  name: 'SelUsers',
  components: { ModalSelUser },
  props: {
    value: {
      type: [Array, Object],
      default () { // selectedItems
        return []
      }
    },
    maxSelect: {type: Number, required: false, default: 100000},
    getDels: {type: Boolean, required: false, default: false},
    buttonName: {type: String, required: false, default: 'ユーザー選択'},
    inputName: {type: String, required: false, default: 'users[]'},
    view_mode: {type: Boolean, required: false, default: false}, // 表示モード
    doReset: {type: Boolean, required: false, default: false} // リセットフラグ
  },
  data () {
    return {
      initialized: false,
      // ユーザー選択モーダル
      modalSelUser: {
        isOpen: false,
        selectedIds: [],
        selectedItems: []
      }
    }
  },
  watch: {
    value (newValue, oldValue) {
      // 初回のみ
      if (!oldValue || newValue.length !== oldValue.length) {
        this.initData()
      }
    },
    doReset (newValue) {
      if (newValue) {
        this.initialized = false
        this.initData()
      }
    }
  },
  created () {
    this.initData()
  },
  methods: {
    initData () {
      // 親画面のロードに合わせるためのwatchなので、
      // 最初の1回だけ実行する
      // （そうでないとwatch.valueが無限ループになる）
      if (this.initialized) {
        return
      }

      let items = []
      // 1件の場合arrayにする
      if (Array.isArray(this.value)) {
        items = this.value
      }
      else {
        if (this.value) {
          items = [this.value]
        }
      }

      // 初期化してから入れ直す
      this.modalSelUser.selectedItems = []
      this.modalSelUser.selectedIds = []

      for (let item of items) {
        this.modalSelUser.selectedItems.push(item)
        this.modalSelUser.selectedIds.push(item.id)
      }

      this.initialized = true
    },
    /**
     * ユーザー選択ダイアログを開く
     * @param modalSelUser
     */
    openModalSelUser () {
      this.modalSelUser.isOpen = true
    },
    /**
     * 選択ユーザーを解除する
     * @param modalSelUser
     */
    removeSelectedUser (index) {
      this.modalSelUser.selectedIds.splice(index, 1)
      this.modalSelUser.selectedItems.splice(index, 1)
      this.onChangeSelectedUsers(this.modalSelUser)
    },
    onChangeSelectedUsers (modalSelUser) {
      // 新規画面の場合、こちらでフラグを立てておく
      // （そうでないとwatch.valueが無限ループになる）
      this.initialized = true

      this.$emit(
        'input',
        // 単数選択の場合は配列じゃなくて1件そのものを返す
        this.maxSelect === 1 ? modalSelUser.selectedItems[0] : modalSelUser.selectedItems
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.loading {
  text-align: center;
}

.sel-users-btn + .selected-box {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/SelUsers.vue